export default "__VITE_ASSET__AGPocuRw__"